// Backend country code -> display label. Keys are lowercase because a season's
// `country` attribute is the DDB country code (e.g. 'usa' from 'Radical#usa').
export const JURISDICTION_LABELS = {
  usa: 'United States',
  uk: 'United Kingdom',
  canada: 'Canada',
  australia: 'Australia',
  germany: 'Germany',
  france: 'France',
  ireland: 'Ireland',
};

// Country code -> ISO 4217 currency. Same lowercase keys as JURISDICTION_LABELS.
export const COUNTRY_CURRENCY = {
  usa: 'USD',
  uk: 'GBP',
  canada: 'CAD',
  australia: 'AUD',
  germany: 'EUR',
  france: 'EUR',
  ireland: 'EUR',
};

// The default study context is US-centric (see DEFAULT_STUDY_TYPE), so an
// empty/missing country falls back to the US jurisdiction/currency.
export const DEFAULT_JURISDICTION = 'United States';
export const DEFAULT_CURRENCY = 'USD';

// Resolve a season's country code to its display label. An empty/missing code
// falls back to the default (US) jurisdiction, but a genuinely unknown code is
// returned as-is rather than mislabeled as the default — otherwise a real
// non-default season with an unmapped code would silently read as "United States".
export const jurisdictionLabel = country => {
  const code = String(country || '').toLowerCase();
  if (!code) return DEFAULT_JURISDICTION;
  return JURISDICTION_LABELS[code] || country;
};

// Resolve a season's country code to its ISO 4217 currency, falling back to USD
// for empty/missing or unmapped codes.
export const currencyForCountry = country =>
  COUNTRY_CURRENCY[String(country || '').toLowerCase()] || DEFAULT_CURRENCY;
